export default str =>
    encodeURIComponent(
        (str || 'untitled')
            .toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^A-Za-zäöü\d-]/gi, '')
    )
